import styled from 'styled-components';
import { bgFadeIn } from '../../styled-components'

export const Container = styled.div `
    border-left: solid 1px #e4e4e4;
    padding-bottom: 20px;
    position: relative;
    &:before {
      content: '';
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background-color: #2a2444;
      position: absolute;
      top: 0;
      left: -4px;
    }
    &:first-child {
      &:before {
        border: solid 1px #2a2444;
        background-color: #887fff;
        animation: ${bgFadeIn} 2s linear infinite;
      }
    }
    &:nth-last-child(1) {
      border-left: none;
    }
`;

export const List = styled.div `
  display: flex;
  padding-left: 17px;
  position: relative;
  top: -5px;
  cursor: pointer;
`;

export const EventName = styled.div `
  font-family: 'AvenirNext-Medium';
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
  flex: 1;
  text-transform: lowercase;
`;

export const EventTime = styled.div `
  font-family: 'AvenirNext';
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #96979a;
`;
